import React from "react";

const LoaderTutorProfileGreen = () => {
  return (
    <div>
      <div className="bg-green-100 h-screen px-5 pt-5 z-40 zMain">
        <div className="flex flex-row gap-5">
          <div className="bg-white rounded-lg h-[640px] w-[25%] flex flex-col gap-5 px-5">
            <div
              role="status"
              class="max-w-sm p-4   rounded mt-5 animate-pulse md:p-6 "
            >
              <div class="flex items-center justify-center h-48 mb-4 bg-gray-300 rounded dark:bg-gray-700">
                <svg
                  class="w-10 h-10 text-gray-200 dark:text-gray-600"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 16 20"
                >
                  <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                  <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                </svg>
              </div>
              <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
              <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
              <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
              <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              <div class="flex items-center mt-4">
                <svg
                  class="w-10 h-10 me-3 text-gray-200 dark:text-gray-700"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                </svg>
                <div>
                  <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>
                  <div class="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                </div>
              </div>
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div className="w-[75%] bg-white h-screen rounded-lg">
            <div className="rounded-xl bg-white h-[385px] w-full p-5 animate-pulse">
              <div class="h-4.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[200px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[140px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[160px]"></div>
              <span class="sr-only">Loading...</span>
            </div>
            <div className="rounded-xl bg-white h-[385px] w-full p-5 animate-pulse mt-10">
              <div class="h-4.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[200px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[140px] mb-2.5"></div>
              <div class="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[160px]"></div>
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoaderTutorProfileGreen;
